var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUptimeSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 188,
    viewBox: "0 0 355 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 16C0.333496 7.16344 7.49694 0 16.3335 0H339C347.837 0 355 7.16344 355 16V172C355 180.837 347.837 188 339 188H16.3335C7.49692 188 0.333496 180.837 0.333496 172V16Z",
    fill: "#0052FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.764 129.753H224.555V136.2H215.764V129.753Z",
    fill: "#00D17F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.778 129.753H139.57V136.2H130.778V129.753Z",
    fill: "#00D17F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.899 127.675C213.899 121.789 218.67 117.018 224.555 117.018V129.806H214.112C213.972 129.117 213.899 128.404 213.899 127.675Z",
    fill: "#00D17F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.435 127.675C141.435 121.789 136.663 117.018 130.778 117.018V129.806H141.221C141.361 129.117 141.435 128.404 141.435 127.675Z",
    fill: "#00D17F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153.05 65.8668C151.108 65.8668 149.533 67.4412 149.533 69.3834V104.55C149.533 106.492 151.108 108.067 153.05 108.067H202.283C204.225 108.067 205.8 106.492 205.8 104.55V69.3834C205.8 67.4412 204.225 65.8668 202.283 65.8668H196.422V70.5557H158.911V65.8668H153.05Z",
    fill: "#00D17F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.711 33.0447H135.467V51.8002H116.711V33.0447Z",
    fill: "#0052FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M116.711 136.2H135.467V154.955H116.711V136.2Z",
    fill: "#0052FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 33.0447H238.622V51.8002H219.866V33.0447Z",
    fill: "#0052FF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 136.2H238.622V154.955H219.866V136.2Z",
    fill: "#0052FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M116.711 51.8002H135.467V136.2H116.711V51.8002Z",
    fill: "#CED2DB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 33.0447L219.866 51.8002L135.467 51.8002L135.467 33.0447L219.866 33.0447Z",
    fill: "#CED2DB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 136.2L219.866 154.955L135.467 154.955L135.467 136.2L219.866 136.2Z",
    fill: "#CED2DB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 51.8002H238.622V136.2H219.866V51.8002Z",
    fill: "#CED2DB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.141 122.548L224.97 121.719L229.244 125.993L233.519 121.719L234.348 122.548L229.244 127.651L224.141 122.548Z",
    fill: "#101114"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.192 65.4524L130.364 66.2812L126.089 62.0068L121.815 66.2812L120.986 65.4524L126.089 60.349L131.192 65.4524Z",
    fill: "#101114"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 116.272C143.672 114.33 145.247 112.755 147.189 112.755H208.144C210.086 112.755 211.661 114.33 211.661 116.272V136.2H143.672V116.272Z",
    fill: "#00D17F"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M158.911 70.5557H196.422V94H158.911V70.5557Z",
    fill: "#0A0B0D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.431 83.1836H149.533V91.3891H145.431V83.1836Z",
    fill: "#0052FF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.903 91.0695L205.8 91.0695L205.8 82.8639L209.903 82.8639L209.903 91.0695Z",
    fill: "#0052FF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.431 87.8725H141.328V86.7003H145.431V87.8725Z",
    fill: "#101114"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M209.903 86.3806L214.005 86.3806L214.005 87.5528L209.903 87.5528L209.903 86.3806Z",
    fill: "#101114"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M164.772 108.067H190.561V112.755H164.772V108.067Z",
    fill: "#0A0B0D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M182.356 70.5557H187.045V94H182.356V70.5557Z",
    fill: "#0052FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.723 80.3629L173.047 83.2937L177.371 80.3629L181.687 83.2935L186.01 80.3632L190.334 83.294L194.171 80.6972L195.157 82.1534L190.333 85.4177L186.01 82.4874L181.686 85.4182L177.37 82.4876L173.047 85.4179L168.724 82.4876L164.407 85.4182L159.59 82.153L160.577 80.6975L164.407 83.2935L168.723 80.3629Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M158.911 68.2112H196.422V70.5557H158.911V68.2112Z",
    fill: "#00D17F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.147 103.378V98.6889H192.319V103.378H191.147Z",
    fill: "#0A0B0D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M186.458 103.378V98.6889H187.631V103.378H186.458Z",
    fill: "#0A0B0D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.77 103.378V98.6889H182.942V103.378H181.77Z",
    fill: "#0A0B0D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M177.081 103.378V98.6889H178.253V103.378H177.081Z",
    fill: "#0A0B0D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.392 103.378V98.6889H173.564V103.378H172.392Z",
    fill: "#0A0B0D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.703 103.378V98.6889H168.875V103.378H167.703Z",
    fill: "#0A0B0D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M163.014 103.378V98.6889H164.186V103.378H163.014Z",
    fill: "#0A0B0D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M211.661 117.444H212.247C214.189 117.444 215.764 119.019 215.764 120.961V136.2H211.661V117.444Z",
    fill: "#0A0B0D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M143.672 117.444H143.086C141.144 117.444 139.57 119.019 139.57 120.961V136.2H143.672V117.444Z",
    fill: "#0A0B0D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M168.875 124.185C168.875 126.612 167.038 128.58 164.772 128.58C162.507 128.58 160.67 126.612 160.67 124.185C160.67 121.757 162.507 119.789 164.772 119.789C167.038 119.789 168.875 121.757 168.875 124.185Z",
    fill: "#0A0B0D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M181.769 124.185C181.769 126.612 179.933 128.58 177.667 128.58C175.401 128.58 173.564 126.612 173.564 124.185C173.564 121.757 175.401 119.789 177.667 119.789C179.933 119.789 181.769 121.757 181.769 124.185Z",
    fill: "#0052FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M194.664 124.185C194.664 126.612 192.827 128.58 190.561 128.58C188.295 128.58 186.458 126.612 186.458 124.185C186.458 121.757 188.295 119.789 190.561 119.789C192.827 119.789 194.664 121.757 194.664 124.185Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M116.711 23.667H135.467V33.0447H116.711V23.667Z",
    fill: "#CED2DB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 23.667H238.622V33.0447H219.866V23.667Z",
    fill: "#CED2DB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M116.711 154.955H135.467V164.333H116.711V154.955Z",
    fill: "#CED2DB"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M219.866 154.955H238.622V164.333H219.866V154.955Z",
    fill: "#CED2DB"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M107.334 33.0447H116.711V51.8002H107.334V33.0447Z",
    fill: "#CED2DB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M107.334 136.2H116.711V154.955H107.334V136.2Z",
    fill: "#CED2DB"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M238.622 136.2H248V154.955H238.622V136.2Z",
    fill: "#CED2DB"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M238.622 33.0447H248V51.8002H238.622V33.0447Z",
    fill: "#CED2DB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.467 41.8363H229.83V126.822H228.658V43.0086H135.467V41.8363Z",
    fill: "#101114"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.503 61.764H126.675V144.991H219.867V146.164H125.503V61.764Z",
    fill: "#101114"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M232.175 145.578C232.175 147.196 230.863 148.508 229.244 148.508C227.626 148.508 226.314 147.196 226.314 145.578C226.314 143.959 227.626 142.647 229.244 142.647C230.863 142.647 232.175 143.959 232.175 145.578Z",
    fill: "#101114"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M129.02 42.4225C129.02 44.0409 127.708 45.353 126.089 45.353C124.471 45.353 123.159 44.0409 123.159 42.4225C123.159 40.804 124.471 39.4919 126.089 39.4919C127.708 39.4919 129.02 40.804 129.02 42.4225Z",
    fill: "#101114"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUptimeSecurity);
export default __webpack_public_path__ + "static/media/UptimeSecurity.fbc699da34cdff31b87ec3854a6e3c3c.svg";
export { ForwardRef as ReactComponent };